/* Red Bear Co. Global JavaScript */

// Add to cart functionality
document.addEventListener('DOMContentLoaded', function() {
  
  // Handle add to cart forms
  const addToCartForms = document.querySelectorAll('.product-form');
  
  addToCartForms.forEach(form => {
    form.addEventListener('submit', async function(e) {
      e.preventDefault();
      
      const formData = new FormData(form);
      const button = form.querySelector('button[type="submit"]');
      const originalText = button.textContent;
      
      // Disable button and show loading state
      button.disabled = true;
      button.textContent = 'Adding...';
      
      try {
        const response = await fetch(window.routes.cart_add_url, {
          method: 'POST',
          body: formData
        });
        
        if (response.ok) {
          const cart = await response.json();
          
          // Update cart count
          updateCartCount(cart.item_count);
          
          // Show success state
          button.textContent = 'Added!';
          setTimeout(() => {
            button.textContent = originalText;
            button.disabled = false;
          }, 2000);
        } else {
          throw new Error('Failed to add to cart');
        }
      } catch (error) {
        console.error('Error adding to cart:', error);
        button.textContent = 'Error - Try Again';
        setTimeout(() => {
          button.textContent = originalText;
          button.disabled = false;
        }, 2000);
      }
    });
  });
  
  // Update cart count in header
  function updateCartCount(count) {
    const cartCountElement = document.querySelector('.cart-count');
    if (cartCountElement) {
      cartCountElement.textContent = count;
      if (count > 0) {
        cartCountElement.classList.remove('cart-count--empty');
      }
      
      // Add a little animation
      cartCountElement.style.transform = 'scale(1.3)';
      setTimeout(() => {
        cartCountElement.style.transform = 'scale(1)';
      }, 300);
    }
  }
  
  // Smooth scroll for anchor links
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      const href = this.getAttribute('href');
      if (href !== '#' && href !== '') {
        e.preventDefault();
        const target = document.querySelector(href);
        if (target) {
          target.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      }
    });
  });
  
});